// extracted by mini-css-extract-plugin
module.exports = {"div":"PhotoPerfil_div__3iiTO","img":"PhotoPerfil_img__1mnGQ","p":"PhotoPerfil_p__1U1EW"};